import { device } from '@ui-components/breakpoints';
import {
    cookieYellow1,
    fontWeightBold,
    iconArrowLeft,
    playTransitionEasing,
    regularWhite,
} from '@ui-components/design-tokens';
import SwitchInput, { InputSize, SwitchInputTheme } from '@ui-components/SwitchInput';
import { SettingsLabel, Switch } from '@ui-components/SwitchInput/SwitchInput.styles';
import { playFontIcon, playFontSize } from '@ui-components/typography/helpers';
import { playFocus } from '@ui-components/utils.styles';
import styled, { css } from 'styled-components';

export const StyledCookieSettingsGroup = styled.div`
    padding: 15px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &:last-of-type {
        border-bottom: none;
    }
`;
export const StyledCookieSettingsGroupHeader = styled.div`
    display: flex;
`;

export const StyledCookieSettingsGroupHeading = styled.h2`
    ${playFontSize(1.5)};
    margin-bottom: 7px;
    color: ${cookieYellow1};
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    cursor: pointer;

    a {
        width: 100%;
    }

    a:hover {
        text-decoration: underline;
        text-underline-position: under;
    }

    @media ${device.GteMedium} {
        flex-direction: row;
        ${playFontSize(1.7)};
    }
`;

export const StyledCookieConsentSwitchInput = styled(SwitchInput).attrs({
    size: InputSize.Small,
    theme: SwitchInputTheme.Secondary,
})`
    margin-top: 0;
    transform-origin: top;
    display: inline-flex;
    flex-direction: row-reverse;
    align-items: center;
    align-self: flex-end;

    ${SettingsLabel} {
        margin-right: 10px;
        ${playFontSize(1.44)}
        font-weight: ${fontWeightBold};
        line-height: 1;
        margin-bottom: 0;
    }

    ${Switch} {
        margin: 0;
    }
`;

export const StyledMessage = styled.p`
    margin-top: 0;
    transform-origin: top;
    font-weight: ${fontWeightBold};
    display: inline-flex;
    flex-direction: row-reverse;
    align-items: center;
    ${playFontSize(1.2)}
    color: ${regularWhite};
    margin-right: 5px;
    width: 100%;
`;

export const StyledCookieSettingsGroupContent = styled.div<{ expanded?: boolean }>`
    display: ${({ expanded }) => (expanded ? 'block' : 'none')};
`;

export const StyledCookieSettingsGroupDetails = styled.div`
    background-color: ${cookieYellow1}1a;
    padding: 15px;
    ${playFontSize(1.3)}
    color: ${regularWhite};
    line-height: 1.5;
    margin-bottom: 10px;
    border-radius: 4px;
`;

export const StyledCookieSettingsGroupDetailsDescription = styled.p<{ expanded?: boolean }>`
    ${playFontSize(1.3)}
    color: ${regularWhite};
    line-height: 1.5;
    max-width: 85%;

    ${({ expanded }) =>
        expanded &&
        css`
            margin-bottom: 20px;
        `}
`;
export const StyledCookieSettingsGroupDetailsHeading = styled.h3<{ expanded?: boolean }>`
    ${playFontSize(1.5)}
    color: ${regularWhite};
    line-height: 1.5;
    font-weight: ${fontWeightBold};
`;

export const StyledCookieSettingsGroupDetailsSubHeading = styled.p`
    ${playFontSize(1.3)}
    color: ${regularWhite};
    line-height: 1.5;
`;

export const InfoList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const InfoListItem = styled.li`
    margin-bottom: 15px;
    color: ${regularWhite};
    ${playFontSize(1.5)}
    display: inline-flex;
    align-items: center;
`;

export const InfoListSvg = styled.svg`
    margin-right: 40px;
    width: 30px;
`;

export const Divider = styled.hr`
    margin: 30px 0;
    background-color: rgba(255, 255, 255, 0.1);
    height: 1px;
    border: none;
`;

export const StyledCookieConsentBackButton = styled.button`
    background: none;
    border: none;
    ${playFontSize(1.2)};
    color: ${regularWhite};
    display: inline-flex;
    align-items: center;
    ${playFocus()}

    &:before {
        ${playFontIcon(1.2, iconArrowLeft)};
        margin-right: 5px;
        transition: transform 200ms ${playTransitionEasing};
    }

    &:hover {
        span {
            text-decoration: underline;
            text-underline-position: under;
        }
    }

    &:hover:before {
        transform: translateX(-4px);
    }
`;

export const StyledExpandHeading = styled.button``;
